import React, { createContext, useContext, useEffect, useState } from 'react';
import { MobileFocus, IMobileFocusContext } from "./types";


export const MobileFocusContext = createContext<IMobileFocusContext>(null!);

export function MobileFocusProvider(props: React.PropsWithChildren<unknown>) {
    const [mobileFocus, setMobileFocus] = useState<MobileFocus>("drawer");

    const contextValue = {
        mobileFocus,
        setMobileFocus: setMobileFocus
    } as IMobileFocusContext;

    return <MobileFocusContext.Provider value={{ ...contextValue }}>
            {props.children}
        </MobileFocusContext.Provider>;
}

export function useMobileFocus() {
    const context = useContext(MobileFocusContext);

    if (!context) {
        throw new Error('useMobileFocus must be used within the MobileFocusProvider');
    }

    return context;
}
